import { render, staticRenderFns } from "./ModificaLavoro.vue?vue&type=template&id=b4d030ea&scoped=true"
import script from "./ModificaLavoro.vue?vue&type=script&lang=js"
export * from "./ModificaLavoro.vue?vue&type=script&lang=js"
import style0 from "./ModificaLavoro.vue?vue&type=style&index=0&id=b4d030ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d030ea",
  null
  
)

export default component.exports